module.exports = "pegasus_template/assets/blocks/capture-3-basic.png";